import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import 'moment/locale/ko';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import OrderController, {
  KnockOrderLandingItemType,
  OrderChildType,
} from '../controller/OrderController';
import { langText } from '../recoil/lang';
import { getProductName } from '../utils/util';
import LangSelectBox from './LangSelectBox';

interface PropsType {
  orderData: any;
  setVisibleCancel: any;
  setVisibleStaff: any;
  setVisibleRollback: any;
  orderStatus: string;
  lang: number;
  setLang: any;
}
interface OrderStatusTextEntry {
  statusText: string;
  subText: string;
  icon: string;
}

const StaffConfirm = ({
  orderData,
  setVisibleCancel,
  setVisibleStaff,
  setVisibleRollback,
  orderStatus,
  lang,
  setLang,
}: PropsType) => {
  const orderStatusText: { [key: string]: OrderStatusTextEntry } = {
    ORDER_WATING: {
      statusText: langText.order_waiting_title[lang],
      subText: langText.order_waiting_sub_title[lang],
      icon: `${process.env.PUBLIC_URL}/svg/status_waiting.svg`,
    },
    ORDER_READY: {
      statusText: langText.order_ready_title[lang],
      subText: langText.order_ready_sub_title[lang],
      icon: `${process.env.PUBLIC_URL}/svg/status_success.svg`,
    },
    ORDER_CANCEL: {
      statusText: langText.order_cancel_title[lang],
      subText: langText.order_cancel_sub_title[lang],
      icon: `${process.env.PUBLIC_URL}/svg/status_cancel.svg`,
    },
    ORDER_SUCCESS: {
      statusText: langText.order_success_title[lang],
      subText: langText.order_success_sub_title[lang],
      icon: `${process.env.PUBLIC_URL}/svg/status_success.svg`,
    },
  };
  const orderDetailData: OrderChildType = orderData?.child[0];
  const { statusText = '', subText = '', icon = `` } = orderStatusText[orderStatus] || {};
  const isCancelRequested = orderDetailData.request_cancel === 1 && orderStatus !== 'ORDER_CANCEL';
  const waitingIcon = `${process.env.PUBLIC_URL}/svg/status_waiting.svg`;

  const OrderDetail = () => {
    return (
      <div className="orderListWrap">
        <div className="orderList">
          <div className="storeInfo">
            <h3>{orderData.store_name}</h3>
            <a href={`tel:${orderDetailData.store_phone_number}`}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_phone.svg`} alt="전화 아이콘" />
            </a>
          </div>
          <p>{orderDetailData.store_address1}</p>
          <p> {orderDetailData.store_address2}</p>
        </div>
        <div className="orderList">
          {orderDetailData.detail.map((data, index) => (
            <div className="orderDetail" key={index}>
              <h5 className="productName">{getProductName(data, lang)}</h5>
              <h5>{data.product_quantity}개</h5>
            </div>
          ))}
        </div>
        <div className="orderList">
          <h4>{orderDetailData.total_amount_incl.toLocaleString()}원</h4>
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="wrap">
        <div className="title">
          {/* <h2>{langText.main_title[lang]}</h2> */}
          <LangSelectBox lang={lang} setLang={setLang} />
        </div>
        <div className="orderStatus">
          <div className="statusIcon">
            <img
              className="circlePath"
              src={isCancelRequested ? waitingIcon : icon}
              alt={isCancelRequested ? '준비중 아이콘' : '주문상태 아이콘'}
            />
          </div>
          <div className="statusText">
            <h2>{isCancelRequested ? langText.order_cancel_request[lang] : statusText}</h2>
          </div>
          <div className="subText">
            <h5>{isCancelRequested ? langText.order_cancel_request_text[lang] : subText}</h5>
          </div>
        </div>

        <div className="orderDetailWrap">
          <p className="orderTime">
            {moment(orderDetailData.ordered_at).format('YYYY-MM-DD HH:mm:ss')}
          </p>
          <OrderDetail />
        </div>
        {orderStatus === 'ORDER_READY' && orderDetailData.request_cancel !== 1 && (
          <button onClick={() => setVisibleStaff(true)} className="successButton">
            <p>직원 확인</p>
          </button>
        )}
        {orderDetailData.request_cancel !== 1 &&
          orderStatus !== 'ORDER_CANCEL' &&
          orderStatus !== 'ORDER_SUCCESS' && (
            <div className="cancelOrderWrap">
              <button onClick={() => setVisibleCancel(true)}>
                <p>{langText.cancel_order[lang]}</p>
              </button>
            </div>
          )}
        {orderStatus === 'ORDER_SUCCESS' && (
          <button onClick={() => setVisibleRollback(true)} className="rollbackButton">
            <p>사용완료 복원</p>
          </button>
        )}
      </div>
    </Style>
  );
};

export default StaffConfirm;

export const Style = styled.div`
  h2 {
    font-size: 24px;
    font-weight: 600;
    color: #555;
  }
  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #555;
  }
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: #555;
  }
  h5 {
    font-size: 16px;
    font-weight: 400;
    color: #555;
    line-height: 25px;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    color: #a7a7a7;
  }

  /* wrap */
  .wrap {
    width: 100%;
    min-height: 100vh;
    padding: 0 3vw;
    background: #f5f6fa;
  }
  .title {
    padding: 20px 3vw 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    h2 {
      flex: 1;
      font-size: 20px;
      font-weight: 600;
      color: #555;
      text-align: center;
      margin-left: 80px;
    }
  }

  /* orderStatus */
  .orderStatus {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;

    .subText {
      width: 90%;
      text-align: center;
      white-space: pre-line;
    }
  }
  .statusIcon {
    margin-bottom: 18px;
  }

  /* orderDetailWrap */
  .orderDetailWrap {
    margin: 32px 0 20px 0;

    .orderTime {
      text-align: right;
    }
  }
  .orderListWrap {
    margin-top: 7px;
    padding: 20px 30px;
    background: #fff;
    border-radius: 20px;

    .storeInfo {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-bottom: 10px;
    }
    .orderList {
      padding: 23px 0;
      border-bottom: 1px solid #f5f6fa;
    }
    .orderList:last-child {
      border: none;
    }
    .orderDetail {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .productName {
      max-width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  /* cancelOrderWrap */
  .cancelOrderWrap {
    padding-bottom: 30px;
    margin-top: 24px;

    button {
      width: 100%;
      margin: 0 auto;
      text-align: center;
    }
    p {
      text-decoration: underline;
      text-underline-offset: 7px;
    }
  }

  .successButton {
    width: 100%;
    padding: 14px 0;
    background: #4dd2ae;
    border-radius: 10px;
    p {
      color: #fff;
      font-size: 20px;
      font-weight: 600;
    }
  }
  .rollbackButton {
    width: 100%;
    padding: 14px 0;
    background: #cecece;
    border-radius: 10px;

    p {
      color: #fff;
      font-size: 20px;
      font-weight: 600;
    }
  }

`;
